import { useAppSelector } from '@/hooks/use-app-selector'
import { IMultiLevelMenu } from '@interfaces/interfaces'
import React from 'react'
import { Navigation } from '../Base/Navigation/Navigation'

export const GFRDashboardNavigation: React.FC = () => {
  const reportId = useAppSelector((s) => s.axiomReport.selectedReport.reportId)
  const RiskOverviewMenu: IMultiLevelMenu = {
    isDownArrow: false,
    heading: 'Risk Overview',
    isMenuList: false,
    route: `/reports/${reportId}/gfr/dashboard`,
  }
  const RiskHistoryMenu: IMultiLevelMenu = {
    isDownArrow: false,
    heading: 'Risk History',
    isMenuList: false,
    route: `/reports/${reportId}/gfr/summary`,
  }
  const SecurityDetailsMenu: IMultiLevelMenu = {
    isDownArrow: false,
    heading: 'Security Details',
    isMenuList: false,
    route: `/reports/${reportId}/gfr/detail`,
  }

  const headerMenuItems: IMultiLevelMenu[] = [
    RiskOverviewMenu,
    RiskHistoryMenu,
    SecurityDetailsMenu,
  ]
  return (
    <Navigation
      headerMenuItems={headerMenuItems}
      highlightActive={true}
      paddingHorizontal={0}
    />
  )
}
